import { render } from "./BaseSelectInput.vue?vue&type=template&id=9b9144da&ts=true"
import script from "./BaseSelectInput.vue?vue&type=script&lang=ts"
export * from "./BaseSelectInput.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__